export default "__VITE_ASSET__Dq2cQ_08__"